import React from "react";
import { toAbsoluteUrl } from "../../helpers/Reusable";

const AuthBg = () => {
  return (
    <div className="relative flex items-center justify-center bg-cover bg-center min-h-[30rem] h-[30rem] lg:min-h-screen lg:h-full w-full auth-bg-sec">
      <div className="absolute inset-0 z-[2] abs-bg"></div>
      {/* <img
        className="relative z-[1] w-full h-full object-cover"
        src={toAbsoluteUrl("media/img/auth/bg-auth.svg")}
        alt=""
      /> */}
      <div className="absolute z-[3] flex justify-center items-center w-full">
        <img
          className="mx-auto"
          src={toAbsoluteUrl("media/img/logo/main-logo.svg")}
          alt=""
        />
      </div>
    </div>
  );
};

export default AuthBg;
